import React from "react";
import "./mobile-download.css";

const APK_URL = process.env.REACT_APP_MOBILE_APK_URL || "/downloads/fmsar-vhu-mobile.apk";
const API_URL = process.env.REACT_APP_API_URL || "https://jaeval.com/api";
const APK_FILENAME = "fmsar-vhu-mobile.apk";
const APK_BUILD_LABEL = "Version 0.1.0+1 - 03/07/2026";
const APK_SIZE_LABEL = "21.7 MB";

function MobileDownloadPage() {
  return (
    <main className="mobile-download-page">
      <section className="mobile-download-hero">
        <div className="mobile-download-copy">
          <img src="/ja-eval_logo_horizontal_transparent.png" alt="JA-Eval" className="mobile-download-logo" />
          <span className="mobile-download-kicker">Application mobile</span>
          <h1>Jaeval VHU</h1>
          <p>
            Acces mobile pour les ferrailleurs et acheteurs: consulter les lots
            VHU autorises, choisir le vehicule concerne, soumettre une offre en
            MAD, voir le statut de reforme et suivre ses offres.
          </p>

          <div className="mobile-download-actions">
            <a className="mobile-download-primary" href={APK_URL} download>
              <i className="ri-download-cloud-2-line" />
              Telecharger APK
            </a>
            <a className="mobile-download-secondary" href="/login">
              <i className="ri-dashboard-line" />
              Espace web
            </a>
          </div>

            <div className="mobile-download-meta">
              <span><i className="ri-shield-check-line" /> Connexion JWT securisee</span>
              <span><i className="ri-android-line" /> APK: <a href={APK_URL} download>{APK_FILENAME}</a></span>
              <span><i className="ri-price-tag-3-line" /> {APK_BUILD_LABEL}</span>
              <span><i className="ri-hard-drive-2-line" /> Taille: {APK_SIZE_LABEL}</span>
              <span><i className="ri-server-line" /> API: {API_URL}</span>
            </div>
        </div>

        <div className="mobile-download-preview" aria-label="Apercu application mobile">
          <div className="mobile-phone">
            <div className="mobile-phone-top" />
            <div className="mobile-phone-screen">
              <div className="mobile-app-bar">
                <span>Lots VHU</span>
                <i className="ri-refresh-line" />
              </div>
              <div className="mobile-lot-card">
                <span>VHU-2026-001</span>
                <strong>Lot utilitaires sinistres</strong>
                <small>5 vehicules - Fin: 14/06/2026</small>
              </div>
              <div className="mobile-lot-card compact">
                <span>VEHICULE SELECTIONNE</span>
                <strong>Renault Master - 12345-A-6</strong>
                <small>TECHNIQUE - Min. 18 000 MAD</small>
              </div>
              <div className="mobile-lot-card compact">
                <span>VHU-2026-002</span>
                <strong>Lot citadines reformees</strong>
                <small>8 vehicules</small>
              </div>
              <div className="mobile-nav">
                <i className="ri-car-line active" />
                <i className="ri-file-list-3-line" />
                <i className="ri-user-line" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mobile-download-steps">
        <article>
          <i className="ri-android-line" />
          <h2>Installation Android</h2>
          <p>Telechargez l'APK, ouvrez le fichier sur le telephone, puis autorisez l'installation si Android le demande.</p>
        </article>
        <article>
          <i className="ri-lock-password-line" />
          <h2>Connexion</h2>
          <p>Utilisez votre identifiant ferrailleur et votre mot de passe. Le token est conserve localement pour les prochains acces.</p>
        </article>
        <article>
          <i className="ri-auction-line" />
          <h2>Offres VHU</h2>
          <p>Chaque offre est rattachee a un vehicule du lot avec statut de reforme, montant en MAD, delais de paiement, delai d'enlevement, moyen de paiement et acceptation des conditions.</p>
        </article>
      </section>
    </main>
  );
}

export default MobileDownloadPage;
